export default "__VITE_PUBLIC_ASSET__15805bc8__"